<template>
  <div class="">
    <div>
      <a-table :columns="columns" :data-source="displayDistroOrders" :loading="tableLoading" :pagination="pagination"
        class="tableStyle">
        <template slot="orderStatus" slot-scope="status">
          <status-component v-if="status" :status="status"></status-component>
        </template>
        <template slot="confirmed" slot-scope="status">
          <div style="
              display: flex;
              padding-top: 4px;
              justify-content: space-around;
              background: #bcefaf;
              width: 118px;
              height: 27px;
              border-radius: 30px;
            " v-if="status">
            <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
            <p style="font-size: 12px; color: #728c42">Confirmed</p>
          </div>
          <div style="
              display: flex;
              padding-top: 4px;
              justify-content: space-around;
              background: #ff000073;
              width: 118px;
              height: 27px;
              border-radius: 30px;
            " v-else>
            <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
            <p style="font-size: 12px; color: red">Not Confirmed</p>
          </div>
        </template>
        <template slot="action" slot-scope="data">
          <a-dropdown>
            <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon style="font-size: 25px" type="ellipsis" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="showMoreDetails(data)">More Details</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import StatusPill from "../modals/StatusPill.vue";
import { StatusStylesMixins } from "@/mixins/StatusMixins";
import StatusComponent from '../../shared-components/StatusComponent.vue'

export default {
  name: "AllDistroOrders",
  components: { StatusComponent },
  mixins: [StatusStylesMixins],
  props: {
    orders: {
      type: Object,
      default: function () {
        return { data: [] };
      },
    },
  },
  data: () => ({
    tableLoading: false,
    selectedOrder: {},
    pagination: {
      pageSize: 20,
    },
    columns: [
      {
        title: "Order Number",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "Retailer Store",
        dataIndex: "destinationLocationName",
        key: "destinationLocationName",
      },
      {
        title: "Distribution Centre",
        dataIndex: "sourceLocationName",
        key: "sourceLocationName",
      },
      {
        title: "Amount",
        dataIndex: "amount",
        key: "amount",
      },
      {
        title: "Order Status",
        dataIndex: "orderStatus",
        key: "orderStatus",
        scopedSlots: { customRender: "orderStatus" },
      },
      {
        title: "Ordered Date",
        dataIndex: "createdAt",
        key: "createdAt",
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        scopedSlots: { customRender: "action" },
      },
    ],
    displayDistroOrders: [],
    showUpdateModal: false,
  }),
  watch: {
    orders: function (newOrders) {
      this.setTableData(newOrders);
    },
  },
  methods: {
    showMoreDetails(data) {
      this.$store.dispatch("setOrderInfo", data);
      this.$router.push("/order-details").catch(() => { });
    },
    setTableData(orders) {
      // console.log("new orders", orders);
      this.displayDistroOrders = [...orders.data];
      this.displayDistroOrders.forEach((order) => {
        order.createdAt = moment(order.createdAt).format("DD-MMM-YYYY");
        order.action = order;
        order.confirmed = order.isConfirmed;
        order.orderStatus = order.statusLabel;
        order.amount = order.total
          ? `Ksh ${order.total.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}`
          : "N/A";
        order.quantity = order.requestLines.length;
        order.key = order.id;
      });
    },
    update(data) {
      this.selectedOrder = data;
      this.showUpdateModal = !this.showUpdateModal;
    },
  },
  mounted() {
    // console.log("orders | ", this.orders)
    this.setTableData(this.orders);
  },
};
</script>

<style scoped>
.requestActions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}

.card-container>.ant-tabs-card>.ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  height: 40px;
  color: #98c14b;
  background: #e5efe7;
  border-color: #e5efe7;
  border-bottom: 1px solid #98c14b;
}

.card-container>>>.ant-tabs-tab {
  height: 40px;
  margin: 0;
  width: 217px;
  margin-right: 2px;
  padding: 0 16px;
  line-height: 38px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
}

.card-container>>>.ant-tabs-tab:hover {
  color: #98c14b;
  /* background: #e5efe7; */
}

.modalStyle>>>.ant-modal-header {
  border-bottom: none;
}

.modalStyle>>>.ant-modal-footer {
  border-top: none;
}

.modalStyle {
  display: flex;
  justify-content: center;
}

.card-container>>>.ant-badge-count {
  z-index: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #98c14b;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}

.spinner>>>.ant-spin-dot-item {
  background-color: #418a49;
}

.card-container>.ant-tabs-card>.ant-tabs-bar {
  border-color: #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
  border-color: #e5efe7;
  background: #e5efe7;
}

.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}

button:hover {
  color: #418a49;
  outline-color: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
  background: #26A246;
  color: #fff;

}

.tableStyle>>>.ant-table-thead th {
  background: #fff;
  height: 63px;
}

.tableStyle>>>.ant-table-header {
  background: #fff !important;
}
</style>